import React from "react";
import { Button } from "@shared/ui/button";
import { LucideIcon } from "lucide-react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  buttonName?: string;
  handleSubmit?: () => void;
  icon?: LucideIcon;
  onIconClick?: () => void;
  children?: React.ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  buttonName,
  handleSubmit,
  icon: Icon,
  onIconClick,
  children,
}: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-3">
        {Icon && (
          <div 
            className={`flex items-center justify-center w-8 h-8 rounded-full ${onIconClick ? 'cursor-pointer hover:bg-gray-100 transition-colors' : ''}`}
            onClick={onIconClick}
            role={onIconClick ? "button" : undefined}
          >
            <Icon className="w-5 h-5 text-gray-700" />
          </div>
        )}
        <div className="mb-1">
          <p className="page-title">{title}</p>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
      </div>

      <div className="flex items-center gap-2">
        {buttonName && <Button onClick={handleSubmit}>{buttonName}</Button>}
        {children}
      </div>
    </div>
  );
}
